module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QsVDTQqaZJdSQAAAMpJREFUWMPtVjEOwyAMtK0uyZ4fJGv3ZubZmZudtf0BexnphFRVCgXbhKHc7ruzOQwAHR2NgdzC++0aXs8HAAAY59k8pNHFNg2hqQGJCdQWHOcF1t3i6ROIiLnYpiHkTAUl4TtCSSiJ26FWHuistB/h0ko4ewJS8V/1VEP8O4QpHvVrOM6LTgY43RvnEZwt4qBa4cptQM3A57lX2wNc8dRmJI11KskNSomj0dLOi46AM43cGiohzLnjxnms9hquu8WUEcnfsKPjf/EGrz1fc9Q7wgkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/cald_1.png
// module id = OFV/
// module chunks = 0